export default function () {
  if (!customElements.get('video-component')) {
    class YoutubeVimeoVideo extends HTMLElement {
      constructor() {
        super();
        this.options = JSON.parse(this.dataset.videoOptions);
        if (!this.options['videoType']) return;
        this.playerInner = this.querySelector('.js-video-mount')
        this.playBtn = this.querySelector('.js-video-play-button')
        this.pauseBtn = this.querySelector('.js-video-pause-button')
        this.muteBtn = this.querySelector('.js-video-mute-button')
        this.unMuteBtn = this.querySelector('.js-video-unmute-button')
        this.customVideo = this.querySelector('video')
        this.parent = this.parentElement;
        this.poster = this.querySelector('.js-video-poster');
        if (this.poster) this.posterBtn = this.poster.querySelector('svg');
        this.getAspectRatio()
        this.loadScript().then(this.setupPlayer.bind(this));
        this.initEvents()
      }

      initEvents() {
        if (this.playBtn) this.playBtn.addEventListener('click', () => this.playerPlay())
        if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.playerPause())
        if (this.muteBtn) this.muteBtn.addEventListener('click', () => this.playerMute())
        if (this.unMuteBtn) this.unMuteBtn.addEventListener('click', () => this.playerUnMute())
        if (this.poster) this.posterBtn.addEventListener('click', () => this.playerPlay())
        if (this.poster) this.poster.addEventListener('click', () => this.playerPlay())
      }

      initPlayerEvents(player) {
        if (this.customVideo) {
        } else {
          if (this.options['videoType'] !== 'vimeo') {
            if (player) player.addEventListener('onStateChange', (e) => {
              if(e.data === 1) {
                this.showHideButton(this.playBtn,false);
                this.showHideButton(this.pauseBtn, true);
              } else if (e.data === 2) {
                this.showHideButton(this.playBtn,true);
                this.showHideButton(this.pauseBtn, false);
              }
            })
          } else {
            if (player) player.on('play', (e) => {
              this.showHideButton(this.playBtn,false);
              this.showHideButton(this.pauseBtn, true);
            })

            if (player) player.on('pause', (e) => {
              this.showHideButton(this.playBtn,true);
              this.showHideButton(this.pauseBtn, false);
            })
          }
        }
      }

      loadScript() {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          document.body.appendChild(script);
          script.async = true;
          script.src = this.options['videoType'] === 'youtube'
              ? '//www.youtube.com/iframe_api'
              : '//player.vimeo.com/api/player.js';
          script.onload = resolve;
          script.onerror = reject;
        });
      }

      getAspectRatio() {
        if (this.customVideo) return;

        let url = '';

        if (this.options['videoType'] === 'youtube') {
          url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${this.options['videoId']}`
        } else {
          url = `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.options['videoId']}`
        }

        fetch(url)
            .then(response => response.json())
            .then((responseJson) => {
              if (!responseJson) return;
              const aspectRatio = responseJson.width / responseJson.height;

              if (this.parent) this.parent.style.setProperty('--aspect-ratio', `${aspectRatio}`);
            });
      }

      setupPlayer() {
        if (this.customVideo) {
          this.onPlayerReady();
        } else {
          const playerLoadingInterval = setInterval(() => {
            (this.options['videoType'] === 'youtube')
                ? this.youtubeSetup(playerLoadingInterval)
                : this.vimeoSetup(playerLoadingInterval)
          }, 200)
        }
      }

      youtubeSetup(playerLoadingInterval) {
        if (window.YT !== undefined && window.YT.Player !== undefined) {
          this.player = new YT.Player(this.playerInner, {
            videoId: this.options['videoId'],
            playerVars: {
              autoplay: this.options['autoplay'],
              controls: this.options['controls'],
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              showinfo: 0,
              origin: this.options['requestHost']
            },
            events: {
              onReady: () => {
                this.onPlayerReady();
              },
              onStateChange: (e) => {
                if (e.data === window.YT.PlayerState.ENDED) e.target.seekTo(0);
              }
            }
          });
          clearInterval(playerLoadingInterval);
        }
      }

      vimeoSetup(playerLoadingInterval) {
        if (window.Vimeo) {
          this.player = new Vimeo.Player(this.playerInner, {
            id: this.options['videoId'],
            controls: this.options['controls'],
            muted: true,
            loop: true
          });

          this.player.ready().then(() => {
            this.onPlayerReady();
            this.getAspectRatio();
          })
          clearInterval(playerLoadingInterval);
        }
      }

      onPlayerReady() {
        if (this.options['autoplay']) this.autoPlay()
        this.classList.add('is-loaded')

        this.initPlayerEvents(this.player);
      }

      autoPlay() {
        this.playerMute()
        this.playerPlay()
        this.classList.add('is-playing')
      }

      playerPlay() {
        if (this.customVideo) {
          this.customVideo.play()
        } else {
          (this.options['videoType'] === 'youtube') ? this.player.playVideo() : this.player.play()
        }

        this.classList.add('is-playing');
        this.showHideButton(this.playBtn,false);
        this.showHideButton(this.pauseBtn, true);
        this.hideElement(this.poster);
      }

      hideElement(element) {
        if(element) element.classList.add('visually-hidden');
        if(this.posterBtn) this.posterBtn.removeEventListener('click', () => this.playerPlay());
      }

      showHideButton(button, show = false) {
        if(!button) return;

        if (show) {
          button.style.opacity = 1;
          button.style.visibility = 'visible';
        } else {
          button.style.opacity = 0;
          button.style.visibility = 'hidden';
        }
      }

      playerPause() {
        if (this.customVideo) {
          this.customVideo.pause()
        } else {
          (this.options['videoType'] === 'youtube') ? this.player.pauseVideo() : this.player.pause()
        }
        this.classList.remove('is-playing');
        this.showHideButton(this.playBtn,true);
        this.showHideButton(this.pauseBtn, false);
      }

      playerMute() {
        if (this.customVideo) {
          this.customVideo.muted = true;
        } else {
          (this.options['videoType'] === 'youtube') ? this.player.mute() : this.player.setMuted(true)
        }
        this.classList.add('is-muted')
      }

      playerUnMute() {
        if (this.customVideo) {
          this.customVideo.muted = false;
        } else {
          (this.options['videoType'] === 'youtube') ? this.player.unMute() : this.player.setMuted(false)
        }
        this.classList.remove('is-muted')
      }
    }

    customElements.define('video-component', YoutubeVimeoVideo);
  }
}
